export default __webpack_public_path__ + "static/922-b26a1794e6f2097d28bc110cadab22a1.gif";